import React from 'react'
import { FilterSection, FilterSectionTitle } from './styles'
import PaymentAssignmentFilterUserSelect from './PaymentAssignmentFilterUserSelect'
import type { PaymentAssignmentRolePolicy } from '../Utils/rolePolicy'
import type { FilterUpdateFn, UserOption } from './types'

interface DrawerSectionAssigneeProps {
  rolePolicy: PaymentAssignmentRolePolicy
  isRoleFilterLocked: boolean
  assigneeValue: number[]
  userOptions: UserOption[]
  usersLoading: boolean
  escalatorValue: number[]
  escalatorOptions: UserOption[]
  escalatorsLoading: boolean
  updateFilter: FilterUpdateFn
}

export default function DrawerSectionAssignee({
  rolePolicy,
  isRoleFilterLocked,
  assigneeValue,
  userOptions,
  usersLoading,
  escalatorValue,
  escalatorOptions,
  escalatorsLoading,
  updateFilter,
}: DrawerSectionAssigneeProps) {
  return (
    <FilterSection>
      <FilterSectionTitle>Assignee</FilterSectionTitle>

      {rolePolicy.canFilterByAssignee && (
        <PaymentAssignmentFilterUserSelect
          label="Maker"
          value={assigneeValue}
          onChange={(ids) => updateFilter('assigneeIds', ids)}
          options={userOptions}
          loading={usersLoading}
          disabled={isRoleFilterLocked}
        />
      )}

      {rolePolicy.canFilterByEscalator && (
        <PaymentAssignmentFilterUserSelect
          label="Escalator"
          value={escalatorValue}
          onChange={(ids) => updateFilter('escalatorIds', ids)}
          options={escalatorOptions}
          loading={escalatorsLoading}
          disabled={isRoleFilterLocked}
        />
      )}
    </FilterSection>
  )
}
